document.addEventListener('DOMContentLoaded', function () {

  const openBtn = document.querySelector('[data-compliance-open]');
  const modal = document.querySelector('[data-compliance-modal]');
  const closeBtns = document.querySelectorAll('[data-compliance-close]');

  if (!openBtn || !modal) return;

  let lastFocusedElement = null;

  function openModal() {
    lastFocusedElement = document.activeElement;
    modal.classList.add('is-active');
    document.body.classList.add('compliance-modal-open');
    const closeButton = modal.querySelector('.compliance-modal-close');
    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeModal() {
    modal.classList.remove('is-active');
    document.body.classList.remove('compliance-modal-open');
    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  function getFocusableElements() {
    return modal.querySelectorAll(
      'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
  }

  openBtn.addEventListener('click', function (e) {
    e.preventDefault();
    openModal();
  });

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeModal();
    });
  });

  modal.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    const focusableElements = getFocusableElements();
    if (focusableElements.length === 0) return;
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    // Shift + Tab
    if (e.shiftKey) {
      if (document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
    }
    // Tab
    else {
      if (document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  });
});
